<template>
  <div style="min-height:300px;">
    <div style="text-align:center;">
      <h1 class="title"></h1>
      <div style="height:40px;line-height:40px;background:#f3f3f3">
        <span>发布时间</span>
      </div>
    </div>
    <table style="width:1003px;table-layout:fixed" cellspacing="0" cellpadding="0">
      <colgroup>
        <col style="width:30%" />
        <col style="width:70%" />
      </colgroup>
      <tbody>
        <tr>
          <td style="height:35px;background:#d4ecfc" colspan="2">
            项目基本信息
          </td>
        </tr>
        <tr>
          <td class="qtitle">项目编号：</td>
          <td class="qcontent">
            {{ form.projectCode }}
          </td>
        </tr>
        <tr>
          <td class="qtitle">所在村级：</td>
          <td class="qcontent">
            {{ form.sysOrgName }}
          </td>
        </tr>
        <tr>
          <td class="qtitle">是否发布：</td>
          <td class="qcontent radio_align_label">
            {{ form.published === 1 ? '是' : '否' }}
          </td>
        </tr>
        <tr>
          <td class="qtitle">发布有效期：</td>
          <td class="qcontent radio_align_label">
            <span>{{ form.publishTime }}至{{ form.termOfValidity }}</span>
          </td>
        </tr>
        <tr>
          <td class="qtitle">项目名称：</td>
          <td class="qcontent">
            {{ form.projectName }}
          </td>
        </tr>
        <tr>
          <td class="qtitle">流转方式：</td>
          <td class="qcontent">
            {{ form.transferMode }}
          </td>
        </tr>
        <tr>
          <td class="qtitle">流转期限：</td>
          <td class="qcontent">
            {{ form.transferDeadline }}
          </td>
        </tr>
        <tr>
          <td class="qtitle">交易方式：</td>
          <td class="qcontent">
            {{ form.tradeMode }}
          </td>
        </tr>
        <tr>
          <td class="qtitle">交易期限：</td>
          <td class="qcontent">
            {{ form.tradeDeadline }}
          </td>
        </tr>
        <!--交易-->
        <tr v-show="this.type === '1'">
          <td class="qtitle">登记日期：</td>
          <td class="qcontent">
            {{ form.recordDate }}
          </td>
        </tr>
        <tr v-show="this.type === '1'">
          <td class="qtitle">项目描述：</td>
          <td style="word-wrap:break-word;" v-text="form.description"></td>
        </tr>
        <tr v-show="(this.type === '2') | (this.type === '3')">
          <td class="qtitle">报名时间：</td>
          <td class="qcontent">
            {{ form.applyTime }}
          </td>
        </tr>
        <tr v-show="(this.type === '2') | (this.type === '3')">
          <td class="qtitle">报名地点：</td>
          <td class="qcontent">
            {{ form.applySite }}
          </td>
        </tr>
        <tr v-show="(this.type === '2') | (this.type === '3')">
          <td class="qtitle">交易开始时间：</td>
          <td class="qcontent">
            {{ form.tradeStartTime }}
          </td>
        </tr>
        <tr v-show="(this.type === '2') | (this.type === '3')">
          <td class="qtitle">交易地点：</td>
          <td></td>
        </tr>
        <tr v-show="(this.type === '2') | (this.type === '3')">
          <td class="qtitle">公告日期：</td>
          <td>
            {{ form.tradeSite }}
          </td>
        </tr>
        <tr>
          <td style="height:35px;background:#d4ecfc" colspan="2">
            产权基本信息
          </td>
        </tr>
        <tr v-show="(this.type === '2') | (this.type === '3')">
          <td class="qtitle">登记日期：</td>
          <td class="qcontent">{{ form.recordDate }}</td>
        </tr>
        <tr v-show="(this.type === '2') | (this.type === '3')">
          <td class="qtitle">所有权人：</td>
          <td class="qcontent">{{ form.propertyOwner }}</td>
        </tr>
        <tr>
          <td class="qtitle">是否续租：</td>
          <td class="qcontent">{{ form.isRelet }}</td>
        </tr>
        <tr v-show="(this.type === '2') | (this.type === '3')">
          <td class="qtitle">项目描述：</td>
          <td class="qcontent" v-html="form.description"></td>
        </tr>
        <tr>
          <td class="qtitle">交易面积：</td>
          <td class="qcontent">{{ form.area }}亩</td>
        </tr>
        <tr v-show="this.type === '1'">
          <td class="qtitle">产权类型：</td>
          <td class="qcontent">{{ form.propertyType }}</td>
        </tr>
        <tr v-show="this.type === '1'">
          <td class="qtitle">预算总额：</td>
          <td class="qcontent">{{ form.budgetAmount }}</td>
        </tr>
        <tr v-show="this.type === '1'">
          <td class="qtitle">建设单位：</td>
          <td class="qcontent">{{ form.developmentOrg }}</td>
        </tr>
        <tr>
          <td class="qtitle">水利设施类型：</td>
          <td class="qcontent">{{ form.waterFacilityType }}</td>
        </tr>
        <tr>
          <td class="qtitle">设施完好率：</td>
          <td class="qcontent">{{ form.facilityIntactRate }}</td>
        </tr>
        <tr v-show="(this.type === '2') | (this.type === '3')">
          <td class="qtitle">已使用年限：</td>
          <td class="qcontent">{{ form.userYears }}</td>
        </tr>
        <tr v-show="(this.type === '2') | (this.type === '3')">
          <td class="qtitle">资产类型：</td>
          <td class="qcontent">{{ form.assetTypes }}</td>
        </tr>
        <tr v-show="(this.type === '2') | (this.type === '3')">
          <td class="qtitle">利用现状：</td>
          <td class="qcontent">{{ form.projectSite }}</td>
        </tr>
        <tr v-show="this.type === '1'">
          <td class="qtitle">质量等级：</td>
          <td class="qcontent">{{ form.qualityLevel }}</td>
        </tr>
        <tr v-show="this.type === '1'">
          <td class="qtitle">利用现状：</td>
          <td class="qcontent">{{ form.statusQuo }}</td>
        </tr>
        <tr v-show="this.type === '1'">
          <td class="qtitle">项目位置：</td>
          <td class="qcontent">{{ form.projectSite }}</td>
        </tr>
        <tr>
          <td class="qtitle">项目四至：</td>
          <td class="qcontent">{{ form.areaAllDirections }}</td>
        </tr>
        <tr>
          <td class="qtitle">附属设施：</td>
          <td class="qcontent">{{ form.extendFacility }}</td>
        </tr>
        <tr v-show="(this.type === '2') | (this.type === '3')">
          <td class="qtitle">项目周期：</td>
          <td class="qcontent">{{ form.projectCycle }}</td>
        </tr>
        <tr v-show="(this.type === '2') | (this.type === '3')">
          <td class="qtitle">资金来源：</td>
          <td class="qcontent">{{ form.capitalSource }}</td>
        </tr>
        <tr v-show="(this.type === '2') | (this.type === '3')">
          <td class="qtitle">预算总额：</td>
          <td class="qcontent">{{ form.budgetAmount }}</td>
        </tr>
        <tr v-show="(this.type === '2') | (this.type === '3')">
          <td class="qtitle">建设单位：</td>
          <td class="qcontent">{{ form.developmentOrg }}</td>
        </tr>
        <tr v-show="(this.type === '2') | (this.type === '3')">
          <td class="qtitle">产权类型：</td>
          <td class="qcontent">{{ form.propertyType }}</td>
        </tr>
        <tr v-show="(this.type === '2') | (this.type === '3')">
          <td class="qtitle">主要树种：</td>
          <td class="qcontent">{{ form.mainTreeSeeds }}</td>
        </tr>
        <tr v-show="(this.type === '2') | (this.type === '3')">
          <td class="qtitle">平均树龄：</td>
          <td class="qcontent">{{ form.averageTreeAge }}</td>
        </tr>
        <tr v-show="(this.type === '2') | (this.type === '3')">
          <td class="qtitle">株数：</td>
          <td class="qcontent">{{ form.num }}</td>
        </tr>
        <tr v-show="(this.type === '2') | (this.type === '3')">
          <td class="qtitle">平均树高：</td>
          <td class="qcontent">{{ form.averageTreeHeight }}</td>
        </tr>
        <tr v-show="(this.type === '2') | (this.type === '3')">
          <td class="qtitle">平均胸径：</td>
          <td class="qcontent">{{ form.averageDiameter }}</td>
        </tr>
        <tr v-show="(this.type === '2') | (this.type === '3')">
          <td class="qtitle">林木蓄积：</td>
          <td class="qcontent">{{ form.standingCrop }}</td>
        </tr>
        <tr>
          <td class="qtitle">流转用途：</td>
          <td class="qcontent">{{ form.transferPurpose }}</td>
        </tr>
        <tr v-show="this.type === '1'">
          <td class="qtitle">种养品种：</td>
          <td class="qcontent">{{ form.variety }}</td>
        </tr>
        <tr>
          <td class="qtitle">补充说明：</td>
          <td class="qcontent">{{ form.tips }}</td>
        </tr>
        <tr>
          <td style="height:35px;background:#d4ecfc" colspan="2">
            权属信息
          </td>
        </tr>
        <tr v-show="this.type === '1'">
          <td class="qtitle">所有权人：</td>
          <td class="qcontent">{{ form.ownershipType }}</td>
        </tr>
        <tr v-show="this.type === '1'">
          <td class="qtitle">权属类型：</td>
          <td class="qcontent">{{ form.ownershipType }}</td>
        </tr>
        <tr v-show="this.type === '1'">
          <td class="qtitle">权证年限：</td>
          <td class="qcontent">{{ form.timeLimit }}</td>
        </tr>
        <tr v-show="(this.type === '2') | (this.type === '3')">
          <td class="qtitle">使用权人：</td>
          <td class="qcontent">{{ form.contractor }}</td>
        </tr>
        <tr v-show="(this.type === '2') | (this.type === '3')">
          <td class="qtitle">权证名称：</td>
          <td class="qcontent">{{ form.contractedLandUseName }}</td>
        </tr>
        <tr>
          <td class="qtitle">承包权人：</td>
          <td class="qcontent">{{ form.contractor }}</td>
        </tr>
        <tr>
          <td class="qtitle">农村土地承包经营权证编号：</td>
          <td class="qcontent">{{ form.contractedLandUseCode }}</td>
        </tr>
        <tr v-show="this.type === '1'">
          <td class="qtitle">经营权人：</td>
          <td class="qcontent">{{ form.contractedLandUseCode }}</td>
        </tr>
        <tr>
          <td class="qtitle">农村土地承包经营权证名称：</td>
          <td class="qcontent">{{ form.contractedLandUseName }}</td>
        </tr>
        <tr>
          <td class="qtitle">是否存在其他权利人：</td>
          <td class="qcontent">{{ form.isOtherObligee }}</td>
        </tr>
        <tr v-show="(this.type === '2') | (this.type === '3')">
          <td class="qtitle">经营权人：</td>
          <td class="qcontent">{{ form.contractedLandUseCode }}</td>
        </tr>
        <tr>
          <td class="qtitle">他项权利人：</td>
          <td class="qcontent">{{ form.othetItemObligee }}</td>
        </tr>
        <tr v-show="(this.type === '2') | (this.type === '3')">
          <td class="qtitle">权证编号：</td>
          <td class="qcontent">{{ form.warrantCode }}</td>
        </tr>
        <tr v-show="(this.type === '2') | (this.type === '3')">
          <td class="qtitle">权证年限：</td>
          <td class="qcontent">{{ form.timeLimit }}</td>
        </tr>
        <tr>
          <td style="height:35px;background:#d4ecfc" colspan="2">
            流出方信息
          </td>
        </tr>
        <tr>
          <td class="qtitle">单位名称/姓名：</td>
          <td class="qcontent">{{ form.outName }}</td>
        </tr>
        <tr>
          <td class="qtitle">联系人：</td>
          <td class="qcontent">{{ form.outContact }}</td>
        </tr>
        <tr>
          <td class="qtitle">联系电话：</td>
          <td class="qcontent">{{ form.outContactNumber }}</td>
        </tr>
        <tr>
          <td style="height:35px;background:#d4ecfc" colspan="2">
            被委托人信息
          </td>
        </tr>
        <tr>
          <td class="qtitle">姓名：</td>
          <td class="qcontent">{{ form.mandataryName }}</td>
        </tr>
        <tr>
          <td class="qtitle">联系电话：</td>
          <td class="qcontent">{{ form.mandataryContactNumber }}</td>
        </tr>
        <tr>
          <td style="height:35px;background:#d4ecfc" colspan="2">
            评估信息
          </td>
        </tr>
        <tr>
          <td class="qtitle">评估机构：</td>
          <td class="qcontent">{{ form.appraisalFirmName }}</td>
        </tr>
        <tr>
          <td class="qtitle">评估基准日：</td>
          <td class="qcontent">{{ form.assessmentBaseDay }}</td>
        </tr>
        <tr>
          <td class="qtitle">评估值：</td>
          <td class="qcontent">{{ form.assessedValue }}</td>
        </tr>
        <tr v-show="this.type === '3'">
          <td style="height:35px;background:#d4ecfc" colspan="2">
            报名信息
          </td>
        </tr>
        <tr v-show="this.type === '3'">
          <td class="qtitle">报名时间：</td>
          <td class="qcontent">{{ form.registrationTime }}</td>
        </tr>
        <tr v-show="this.type === '3'">
          <td class="qtitle">成交缴款截止时间：</td>
          <td class="qcontent">{{ form.payDeadline }}</td>
        </tr>
        <tr v-show="this.type === '3'">
          <td class="qtitle">联系人：</td>
          <td class="qcontent">{{ form.registrationContact }}</td>
        </tr>
        <tr v-show="this.type === '3'">
          <td class="qtitle">联系电话：</td>
          <td class="qcontent">{{ form.registrationContactNumber }}</td>
        </tr>
        <tr v-show="this.type === '3'">
          <td class="qtitle">交易时间：</td>
          <td class="qcontent">{{ form.registrationTradeTime }}</td>
        </tr>
        <tr v-show="this.type === '3'">
          <td class="qtitle">交易地点：</td>
          <td class="qcontent">{{ form.registrationSite }}</td>
        </tr>
        <tr>
          <td style="height:35px;background:#d4ecfc" colspan="2">
            标段信息
          </td>
        </tr>
        <tr>
          <td class="qtitle">标段编号：</td>
          <td class="qcontent">{{ form.sectionCode }}</td>
        </tr>
        <tr>
          <td class="qtitle">标段描述：</td>
          <td class="qcontent">{{ form.sectionDescription }}</td>
        </tr>
        <tr>
          <td class="qtitle">交易面积：</td>
          <td class="qcontent">{{ form.sectionTradeArea }}亩</td>
        </tr>
        <tr>
          <td class="qtitle">报名费：</td>
          <td class="qcontent">{{ form.entryFee }}</td>
        </tr>
        <tr>
          <td class="qtitle">保证金：</td>
          <td class="qcontent">{{ form.cashDeposit }}</td>
        </tr>
        <tr v-show="this.type === '1'">
          <td class="qtitle">最高限额：</td>
          <td class="qcontent"></td>
        </tr>
        <tr v-show="this.type === '1'">
          <td class="qtitle">交易底价：</td>
          <td class="qcontent"></td>
        </tr>
        <tr>
          <td class="qtitle">预期价格：</td>
          <td class="qcontent">{{ form.expectedPrice }}</td>
        </tr>
        <tr v-show="this.type === '1'">
          <td class="qtitle">交易方式：</td>
          <td class="qcontent">{{ form.tradeMode }}</td>
        </tr>
        <tr>
          <td class="qtitle">补充说明：</td>
          <td class="qcontent">{{ form.sectionTips }}</td>
        </tr>
        <tr v-show="this.type === '1'">
          <td class="qtitle">交易期限：</td>
          <td class="qcontent">{{ form.tradeDeadline }}</td>
        </tr>
        <tr>
          <td class="qtitle">流转期限：</td>
          <td class="qcontent">{{ form.sectionTransferDeadline }}</td>
        </tr>
        <tr>
          <td class="qtitle">成交缴款方式：</td>
          <td class="qcontent">{{ form.payType }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { PropertyRightTransferInfoWebDetail } from '@/api/main/PropertyRightTransferInfo'
import { PropertyRightAfficheWebDetail } from '@/api/main/PropertyRightAffiche'
export default {
  data() {
    return {
      id: '',
      type: '1',
      TransferInfoData: [],
      AfficheData: [],
      loadData: [],
      form: {
        appraisalFirmName: '',
        area: '',
        areaAllDirections: '',
        waterFacilityType: '',
        facilityIntactRate: '',
        assessedValue: '',
        assessmentBaseDay: '',
        cashDeposit: '',
        contractedLandUseCode: '',
        contractedLandUseName: '',
        contractor: '',
        description: '',
        entryFee: '',
        expectedPrice: '',
        extendFacility: '',
        isOtherObligee: '',
        isRelet: '',
        managementPeople: '',
        mandataryContactNumber: '',
        mandataryName: '',
        orgId: '',
        othetItemObligee: '',
        outContact: '',
        outContactNumber: '',
        outName: '',
        owner: '',
        ownershipType: '',
        payType: '',
        projectCode: '',
        projectName: '',
        projectSite: '',
        publishTime: '',
        published: '',
        qualityLevel: '',
        recordDate: '',
        sectionCode: '',
        sectionDescription: '',
        sectionTips: '',
        sectionTradeArea: '',
        sectionTransferDeadline: '',
        statusQuo: '',
        termOfValidity: '',
        timeLimit: '',
        tips: '',
        transferDeadline: '',
        transferMode: '',
        transferPurpose: ''
      }
    }
  },
  created() {
    this.TransferInfoMethod()
  },
  methods: {
    TransferInfoMethod() {
      this.id = this.$route.query.id
      this.type = this.$route.query.type
      if (this.type === '3') {
        PropertyRightTransferInfoWebDetail({ id: this.id }).then(res => {
          this.form = res.data
        })
      } else {
        PropertyRightAfficheWebDetail({ id: this.id }).then(res => {
          this.form = res.data
        })
      }
    }
  }
}
</script>
<style scoped>
.span_main {
  font-size: 15px;
  font-weight: bold;
}
</style>
